<template>
  <div class="mobile-login">
    <div class="mobile-top"></div>

    <div class="zhan"></div>
    <div class="login-box">
      <div class="box">
        <div class="uername" :class="isError ? 'username-error' : ''">
          <select
            v-model="phonePrefix"
            aria-placeholder="請選擇伺服器"
            @change="handleChangeServe()"
          >
            <option selected hidden disabled value="">請選擇</option>
            <option :value="item" v-for="item in phoneTop" :key="item">
              {{ item }}
            </option>
          </select>
          <input
            placeholder="請輸入帳號"
            v-model="username"
            type="number"
            id="username"
            @blur="handleUserBulr"
            @focus="handleUserFocus"
          />
        </div>
        <p class="error">{{ isError ? "請輸入正確的手機號" : "" }}</p>
        <div class="password-box">
          <img src="@/assets/images/password.png" alt="" />
          <input
            placeholder="請輸入密碼"
            type="password"
            id="password"
            v-model="password"
            class="password"
            @blur="handelPassBulr"
          />
        </div>
        <p class="error">{{ isErrorPass ? "請輸入6-10位密碼" : "" }}</p>
        <input
          type="submit"
          value="登 入"
          class="dr"
          @click="handleSubmit()"
          style="margin-bottom: 0.3rem"
        />
        <div class="info-box">使用第三方平臺帳號登入</div>
        <div class="otherLogin">
          <button
            class="other apple"
            id="apple-login"
            @click="handleIOS"
          ></button>
          <!-- <fb-signin-button
            :params="fbSignInParams"
            @success="onFbSignInSuccess"
            @error="onFbSignInError"
          >
            <span class="other face"></span>
          </fb-signin-button> -->
          <div @click="handleGoogleSignIn" class="google"></div>
          <div @click="handleLineLogin" class="line"></div>
        </div>
      </div>
    </div>
    <div class="mobile-footer"></div>
  </div>
</template>

<script>
import { login, rdLogin, rdLoginGe } from "@/api/login";
import { gameList } from "@/api/game";
import moment from "moment";
import { passport, enums, game } from "@/proto/payload.js";
import { Notification } from "element-ui";
import { setAccessToken, setRefreshToken, setUserInfo } from "@/util/auth.js";
import store from "@/store";
import { checkPhone, checkPassWord } from "@/util/check.js";
import { getUrlParams } from "@/util/params";
import qs from "qs";
import axios from "axios";
import { showLoading, hideLoading } from "@/util/loading.js";


const LoginType = enums.LoginType;
const phoneTop = ["+886", "+852", "+853", "+60", "+65", "+86", "+63", "+62"];
export default {
  data() {
    return {
      username: "",
      password: "",
      googleSignInParams: {
        client_id:
          "498606738451-ufrut3a7nu3m2023kg06udf2r506627a.apps.googleusercontent.com",
      },
      fbSignInParams: {
        scope: "email",
        return_scopes: true,
      },
      phoneTop: phoneTop,
      phonePrefix: "+886",
      isError: false,
      isErrorPass: false,
      loadingBtn: null,
    };
  },
  methods: {
    handleSubmit() {
      if (checkPhone(this.phonePrefix, this.username)) {
        return;
      }
      if (checkPassWord(this.password)) {
        return;
      }
      const params = passport.OfficialLoginRequest.create({
        appId: "8",
        phonePrefix: this.phonePrefix,
        phone: this.username.trim(),
        password: this.password,
      });
      const loading = this.$loading({
        lock: true,
        text: "登陸中",
        spinner: "el-icon-loading",
      });
      login(params)
        .then((res) => {
          console.log(res, "11111111111111111111111111111");
          const data = res.data;
          const userInfo = {
            name: data.name,
          };
          setAccessToken(data.info.access_token);
          setRefreshToken(data.info.refresh_token);
          setUserInfo(JSON.stringify(userInfo));
          loading.close();
          this.$router.push({
            path: "/home",
          });
        })
        .catch((res) => {
          loading.close();
          console.log(res);
          if (res == 1) {
            Notification.error({
              message: "賬號或密碼錯誤",
              duration: 3000,
            });
          }
        });
    },
    onSignInError(error) {
      console.log("OH NOES", error);
    },
    // facebook
    onFbSignInSuccess(response) {
      const profile = response.authResponse.accessToken;
      this.getRdLogin(profile, 4);
    },
    onFbSignInError(error) {
      console.log("OH NOES", error);
    },

    // ios
    async handleIOS(val) {
      showLoading('登陸中')
      const data = await AppleID.auth.signIn();
      console.log(data);
      this.getRdLogin(data.authorization.id_token, 5);
    },

    // 谷歌第三方登录
    getRdLogin(key, item) {
      const params = {
        appId: "8",
        account: key,
        loginType: item,
      };
      console.log(params);
      rdLogin(params)
        .then((res) => {
          const data = res.data;
          const userInfo = {
            ...data.accounts,
          };
          setAccessToken(data.info.access_token);
          setRefreshToken(data.info.refresh_token);
          setUserInfo(JSON.stringify(userInfo));
          this.$router.push({
            path: "/home",
          });
        })
        .catch((res) => {
          if (res == 1) {
            Notification.error({
              message: "帳號不存在",
              duration: 3000,
            });
          }
        });
    },

    // 获取手机号前缀
    getGamneList() {
      gameList().then((res) => {
        const data = game.GameListResponse.toObject(res);
        this.phoneTop = data.phonePrefix || [];
      });
    },

    // 账号失焦
    handleUserBulr() {
      this.isError = checkPhone(this.phonePrefix, this.username);
      console.log(this.isError);
    },
    // 账号聚焦
    handleUserFocus() {
      this.isError = false;
    },
    // 密码失焦
    handelPassBulr() {
      this.isErrorPass = checkPassWord(this.password);
    },

    // 选择手机号前缀
    handleChangeServe() {
      if (this.username.length == 0) {
        this.isError = false;
        return;
      }
      this.isError = checkPhone(this.phonePrefix, this.username);
    },

    handleCredentialResponse(e) {
      this.getRdLogin(e.credential, 3);
    },

    handelInitApple() {
      AppleID.auth.init({
        response_type: "code",
        clientId: "com.lmdgame.haikyuu.tw.web",
        scope: "email",
        redirectURI: "https://haikyu.lmdgame.tw/api/v1/sign/apple",
        usePopup: true,
        state: "state",
      });
      document.addEventListener("AppleIDSignInOnSuccess", (data) => {
        console.log(data, "ios success", data.detail.authorization.id_token);
        // this.handleIOS(data.detail.authorization.id_token);
        hideLoading()
      });
      document.addEventListener("AppleIDSignInOnFailure", (error) => {
        console.log(error, "ios error");
        hideLoading()
      });
    },
    handleInitGoogle() {
      const script = document.createElement("script");
      script.src = "https://accounts.google.com/gsi/client";
      script.async = true;
      script.onload = () => {
        console.log("Google Identity Services library loaded.");
      };
      document.head.appendChild(script);
    },

    handleGoogleSignIn() {
      if (!window.google) {
        console.error("Google Identity Services library has not loaded yet.");
        return;
      }

      const client = google.accounts.oauth2.initTokenClient({
        client_id:
          "507235687846-nkn1hl1kv5qun2k7v5a4r87431f0nfk9.apps.googleusercontent.com",
        scope: "openid email",
        callback: (tokenResponse) => {
          console.log(tokenResponse);
          console.log("Access Token:", tokenResponse.access_token);
          this.handleLoginGuge(tokenResponse.access_token);
          // this.getRdLogin(tokenResponse.access_token, 3);
          // 你可以在这里处理获取到的token，例如请求你的后端服务进行用户身份验证
        },
        error_callback:()=>{
          console.log('1');
        }
      });
      console.log(client);
      client.requestAccessToken();
    },
    async handleLineLogin() {
      const line_auth = "https://access.line.me/oauth2/v2.1/authorize";
      const auth_params = {
        response_type: "code",
        client_id: "2003163910",
        redirect_uri: window.location.href, // 在LINE Developers Console上注册的回调 URL 的 URL 编码字符串。您可以添加任何查询参数。
        state: "STATE", // 用于防止跨站点请求伪造的唯一字母数字字符串. 您的网络应用应为每个登录会话生成一个随机值。这不能是 URL 编码的字符串。
        scope: "profile openid email", // 向用户请求的权限,查询范围可以看官网(https://developers.line.biz/en/docs/line-login/integrate-line-login/#scopes)
      };
      // 这里使用了第三方库qs来处理参数
      const paramsString = qs.stringify(auth_params);
      window.location.href = `${line_auth}?${paramsString}`;

      // try {
      //   await liff.init({
      //     liffId: "2003163910-E3GZ4OrL",
      //   });
      //   if (!liff.isLoggedIn()) {
      //     console.log(liff);
      //     // return
      //     liff.login(); // 弹出LINE登录窗口
      //   } else {
      //     const profile = await liff.getProfile();
      //     console.log(profile);
      //     // 处理登录用户的信息，例如显示名称和头像
      //   }
      // } catch (error) {
      //   console.error("Error initializing LINE LIFF:", error);
      // }
    },

    handleLoginGuge(val) {
      const params = {
        access_token: val,
      };
      console.log(params);
      rdLoginGe(params)
        .then((res) => {
          const data = res.data;
          const userInfo = {
            ...data.accounts,
          };
          setAccessToken(data.info.access_token);
          setRefreshToken(data.info.refresh_token);
          setUserInfo(JSON.stringify(userInfo));
          this.$router.push({
            path: "/home",
          });
        })
        .catch((res) => {
          if (res == 1) {
            Notification.error({
              message: "帳號不存在",
              duration: 3000,
            });
          }
        });
    },

    async handleLineToken(val) {

      const params = {
        grant_type: "authorization_code", // 固定值
        code: val.code, // 从 LINE 平台收到的授权码
        client_id: "2003163910",
        client_secret: "bbffac16f6876c6c0a638787f54ea8a6",
        redirect_uri: window.location.origin + window.location.pathname, // 与授权请求redirect_uri中指定的值相同
      };
      const resp = await axios({
        url: "https://api.line.me/oauth2/v2.1/token",
        method: "post",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        data: params,
      });

      console.log(resp);
      this.getRdLogin(resp.data.access_token, 10);
    },
  },
  mounted() {
    this.handleInitGoogle();
    this.handelInitApple();
  },
  created() {
    const url = window.location.search;
    const val = getUrlParams(url);
    console.log(val);
    if (val.code) {
      this.handleLineToken(val);
    }
  },
};
</script>

<style lang="less" scoped>
.mobile-login {
  width: 100%;
  min-height: 100vh;
  position: relative;
  .bg {
    position: absolute;
    width: 100%;
    height: 100vh;
    display: block;
  }
  .login-box {
    width: 100%;
    display: flex;
    height: 194vw;
    flex-direction: column;
    align-items: center;
    position: relative;
    background: url(../../assets/imagePai/mobile/bg.png) 0 0 no-repeat;
    background-size: cover;
    display: flex;
    align-items: center;
    justify-content: center;
    .box {
      width: 79vw;
      height: 78vw;
      position: relative;
      background: url(../../assets/imagePai/mobile/denglukuang.png) 0 0
        no-repeat;
      background-size: cover;
      box-sizing: border-box;
      padding: 20vw 9vw 0;
      .uername {
        display: flex;
        align-items: center;
        box-sizing: border-box;
        border: 1px solid #bfbdbe;
        border-radius: 8px;
        select {
          width: 20vw;
          height: 9vw;
          background: #e0e0e0 url(../../assets/images/caret-bottom.png)
            no-repeat center;
          background-size: 3vw 3vw;
          background-position-x: 120px;
          appearance: none;
          -moz-appearance: none;
          -webkit-appearance: none;
          font-size: 2.4vw;
          color: #000;
          padding-left: 2.4vw;
          box-sizing: border-box;
          border-radius: 8px 0 0 8px;
        }
        input {
          flex: 1;
          height: 9vw;
          background-color: #fff;
          color: #000;
          border-left: 1px solid #bfbdbe;
          margin: 0;
          border-radius: 0 8px 8px 0;
          box-sizing: border-box;
          padding-left: 2.4vw;
          font-size: 2.4vw;
        }
      }
      .password-box {
        background-color: #fff;
        display: flex;
        align-items: center;
        height: 9vw;
        width: 100%;
        box-sizing: border-box;
        border: 1px solid #bfbdbe;
        border-radius: 8px;
        img {
          width: 2.17vw;
          display: flex;
          margin-left: 3vw;
        }
        .password {
          padding-left: 2.41vw;
          box-sizing: border-box;
          background-color: #fff !important;
          margin-bottom: 0;
          width: 48.3vw;
          font-size: 2.4vw;
        }
      }
      .dr {
        color: #000 !important;
        width: 100%;
        font-weight: 600;
        background: url(../../assets/imagePai/mobile/denglu.png) no-repeat;
        cursor: pointer;
        background-size: cover;
        height: 9vw;
        font-size: 3.14vw;
      }
      .otherLogin {
        margin-top: 2.17vw;
        display: flex;
        // align-items: center;
        .apple {
          width: 4.23vw;
          height: 5.07vw;
          background: url(../../assets/imagePai/mobile/Apple.png) no-repeat;
          background-size: cover;
        }

        .face {
          margin-left: 4vw;
          display: inline-block;
          width: 5.07vw;
          height: 5.07vw;
          background: url(../../assets/imagePai/mobile/FB.png) no-repeat;
          background-size: cover;
        }
        .google {
          margin-left: 4vw;
          cursor: pointer;
          width: 5.07vw;
          height: 5.07vw;
          background: url(../../assets/imagePai/mobile/Google.png) no-repeat;
          background-size: cover;
        }
        .line {
          margin-left: 4vw;
          cursor: pointer;
          width: 5.07vw;
          height: 5.07vw;
          background: url(../../assets/imagePai/mobile/LINE.png) no-repeat;
          background-size: cover;
        }
      }
    }
  }
}
.mobile-footer {
  width: 100%;
  height: 54vw;
  width: 100%;
  background: url("../../assets/imagePai/mobile/dibu.png") 0 0 no-repeat;
  background-size: cover;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  color: #fff;
  font-size: 0.25rem;
}

.mobile-footer p {
  color: #fff;
  font-size: 0.24rem;
  text-align: center;
}

.mobile-top {
  background: url("../../assets/imagePai/mobile/dingbu.png");
  background-size: cover;
  width: 100%;
  height: 14vw;
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  img {
    width: 1rem;
  }
  span {
    font-size: 0.25rem;
  }
}

.zhan {
  width: 100%;
  height: 14vw;
}

.error {
  width: 100%;
  height: 0.4rem;
  line-height: 0.4rem;
  color: rgb(245, 108, 108);
  font-size: 2vw;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", SimSun, sans-serif;
}
#g_id_signin {
}
</style>